import { render, staticRenderFns } from "./CMAddMemberGroupMembersList.vue?vue&type=template&id=c884d6b8&scoped=true&"
import script from "./CMAddMemberGroupMembersList.vue?vue&type=script&lang=js&"
export * from "./CMAddMemberGroupMembersList.vue?vue&type=script&lang=js&"
import style0 from "./CMAddMemberGroupMembersList.vue?vue&type=style&index=0&id=c884d6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c884d6b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c884d6b8')) {
      api.createRecord('c884d6b8', component.options)
    } else {
      api.reload('c884d6b8', component.options)
    }
    module.hot.accept("./CMAddMemberGroupMembersList.vue?vue&type=template&id=c884d6b8&scoped=true&", function () {
      api.rerender('c884d6b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accounts/CMAddMemberGroupMembersList.vue"
export default component.exports